<template>
    <div class="container-fluid p-3">
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <div class="title d-flex align-items-center">
                    <inline-svg class="me-2" width="36" height="36" src="/assets/img/icons/globe-01.svg"></inline-svg>
                    Community Library
                </div>
                <div class="subtitle">Card Decks created by other Caregivers.</div>
            </div>
        </div>
        <div class="d-flex flex-row mt-3 align-items-center justify-content-between">
            <div class="d-flex align-items-center w-50">
                <form-input class="me-2 w-100" style="min-width: 320px" v-model="filters.query"
                            placeholder="Search in community" @keypress.enter="search">
                    <template slot="prepend">
                        <inline-svg src="/assets/img/icons/search-icon.svg"></inline-svg>
                    </template>
                </form-input>
            </div>
            <div class="d-flex flex-row align-items-center me-2">
                <span>Sort by</span>
                <form-select class="ms-1" style="margin-right: 20px" v-model="filters.status" @change="search"
                             :options="[
                        {'label': '', 'value': null},
                        {'label': 'Trending', 'value': 'trending'},
                        {'label': 'Popular', 'value': 'popular'},
                        {'label': 'Recent', 'value': 'recent'},
                    ]"
                />
            </div>
            <div>
                <btn-group-toggle :options="[
                    {'label': 'Partners', 'value': 'partner_decks'},
                    {'label': 'Community', 'value': 'community_decks'}
                    ]" v-model="filters.filter_by" @input="getData">
                </btn-group-toggle>
            </div>
            <btn class="btn-light-primary ms-1" @click="$router.push({name: 'card.deck.favorites'})">
                <inline-svg width="16" class="me-1" style="min-width: 16px" src="/assets/img/icons/heart-circle.svg"></inline-svg>
                Favorites
            </btn>
        </div>
        <div class="deck-card-list mt-2" :class="{loading: loading.data}">
            <template v-for="cardDeck in cardDecks">
                <deck-card-partner v-if="cardDeck.corporateBrand"
                                   :cardDeck="cardDeck"
                                   :communityCard="true">
                </deck-card-partner>
                <deck-card-regular v-else
                                   :cardDeck="cardDeck"
                                   :communityCard="true">
                </deck-card-regular>
            </template>
        </div>
        <div v-if="showLoadMore && !loading.data" class="flex-1 text-center">
            <btn class="btn-outline-light" @click="loadMore">
                Load more
                <inline-svg class="ms-1" src="/assets/img/icons/arrow-down.svg"></inline-svg>
            </btn>
        </div>
    </div>
</template>

<script>

import {modelListMixin} from "/src/mixins/modelListMixin.js";
import DeckCardPartner from "@/components/DeckCardPartner.vue";
import DeckCardRegular from "@/components/DeckCardRegular.vue";
import BtnGroupToggle from "@/components/core/BtnGroupToggle.vue";

export default {
  name: 'CommunityLibrary',
  components: {BtnGroupToggle, DeckCardPartner, DeckCardRegular},
  mixins: [modelListMixin],
  data() {
    return {
      cardDecks: [],
      filters: {
        filter_by: 'partner_decks'
      },
      showLoadMore: true,
    };
  },
  mounted() {
    this.getData();
    this.$events.$on('loadCommunityCardDecks', () => {
      this.getData();
    });
  },
  methods: {
    getData() {
      this.loading.data = true;
      this.$http.post("/deck/community-decks", this.filters)
        .then((res) => {
          this.showLoadMore = res.body.data.current_page !== res.body.data.last_page;
          this.cardDecks = this.filters.page === 1 ? res.body.data.data : this.cardDecks.concat(res.body.data.data);
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    loadMore() {
      this.filters.page++;
      this.getData();
    },
  }
};
</script>
